import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import InfoModal from '../InfoModal'
import ProgressButton from '../../../../components/Form/ProgressButton'
import ArchiveButton from './ArchiveButton'
import { ReactComponent as WarningIcon } from '../../../../assets/icons/warning-icon.svg'

import useStyles from './styles'

function DeleteItemModal({
  handleDelete,
  deleteItemError,
  deleteItemIsLoading,
  deletedItemId,
  clearErrorHandler,
  deleteModalMessage,
  isDeleteModalOpened,
  handleCloseDeleteModal,
  deleteButtonText = 'Delete',
  // props for archive button
  archiveProps
}) {
  const { t } = useTranslation()

  const classes = useStyles()

  const modalTitle = archiveProps ? t('Archive or delete?') : t('Are you sure?')

  return (
    <InfoModal
      Icon={WarningIcon}
      modalTitle={modalTitle}
      isOpen={isDeleteModalOpened}
      onClose={handleCloseDeleteModal}
      Buttons={
        <>
          <ProgressButton
            onClick={handleDelete}
            formError={deleteItemError}
            isFormLoading={deleteItemIsLoading}
            successSubmit={deletedItemId}
            clearHandler={clearErrorHandler}
            solid={false}
            primary={false}
            danger
            wrapperClassName={classes.btnWrappers}
          >
            {t(deleteButtonText)}
          </ProgressButton>
          {archiveProps && (
            <ArchiveButton
              {...archiveProps}
              handleCloseDeleteModal={handleCloseDeleteModal}
              wrapperClassName={classes.btnWrappers}
            />
          )}
        </>
      }
    >
      {deleteModalMessage}
    </InfoModal>
  )
}

DeleteItemModal.propTypes = {
  handleDelete: PropTypes.func,
  deleteItemError: PropTypes.func,
  deleteItemIsLoading: PropTypes.bool,
  deletedItemId: PropTypes.string,
  clearErrorHandler: PropTypes.func,
  deleteModalMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isDeleteModalOpened: PropTypes.bool,
  handleCloseDeleteModal: PropTypes.func,
  deleteButtonText: PropTypes.string,
  archiveProps: PropTypes.object
}

export default DeleteItemModal
